/* import __COLOCATED_TEMPLATE__ from './create-tag-from-csv-action.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();